type FormField = Record<string, any>;

const removeStart = (value: string, target?: string) => {
  if (target && value.startsWith(target)) {
    return value.slice(target.length);
  }
  return value;
};

const removeEnd = (value: string, target?: string) => {
  if (target && value.endsWith(target)) {
    return value.slice(0, -target.length);
  }
  return value;
};

const canHandleAddonValue = (value: any) => {
  return value !== undefined && value !== null && !(value instanceof Array) && typeof value !== 'object';
};

export const stripFieldExtraAddonValue = (field: FormField, value: any) => {
  if (!canHandleAddonValue(value)) {
    return value;
  }
  let nextValue = `${value}`;
  if (field?.extraAddonAfter && field?.addonAfter) {
    nextValue = removeEnd(nextValue, field.addonAfter);
  }
  if (field?.extraAddonBefore && field?.addonBefore) {
    nextValue = removeStart(nextValue, field.addonBefore);
  }
  return nextValue;
};

export const normalizeFieldExtraAddonValue = (field: FormField, value: any) => {
  const baseValue = stripFieldExtraAddonValue(field, value);
  if (!canHandleAddonValue(baseValue)) {
    return baseValue;
  }
  if (baseValue === '') {
    return baseValue;
  }
  let nextValue = `${baseValue}`;
  if (field?.extraAddonBefore && field?.addonBefore) {
    nextValue = `${field.addonBefore}${nextValue}`;
  }
  if (field?.extraAddonAfter && field?.addonAfter) {
    nextValue = `${nextValue}${field.addonAfter}`;
  }
  return nextValue;
};
